// Mobile-Menü: Toggle, Overlay-Fade und aufklappbare Subnavigationen.
//
// Hinweis: Die Base-Implementierung (cronus-theme global/js/mobilemenu.js)
// hängt den Aufklapp-Handler ausschließlich an <a>-Elemente
// (querySelectorAll('a')). Die Servicenavigation hat aber einen
// nicht-verlinkten Parent ("Servicebereich") als <span>. Damit dessen
// Submenü im Mobile-Menü aufklappbar ist, behandeln wir hier sowohl
// <a>- als auch <span>-Parents.

const FADE_DURATION = 200;

function fadeIn(el, duration, onDone) {
  if (!el) return;
  el.style.display = '';
  el.style.opacity = '0';
  el.style.transition = `opacity ${duration}ms linear`;
  // erzwingt einen Reflow, damit die Transition greift
  void el.offsetHeight;
  el.style.opacity = '1';
  window.setTimeout(() => {
    if (typeof onDone === 'function') onDone();
  }, duration);
}

function fadeOut(el, duration) {
  if (!el) return;
  el.style.transition = `opacity ${duration}ms linear`;
  el.style.opacity = '0';
  window.setTimeout(() => {
    el.style.display = 'none';
  }, duration);
}

function buildChildrenBackLink(wrapper) {
  const backText = window.GLOBALS?.tc?.back || 'Zurück';
  const li = document.createElement('li');
  const backLink = document.createElement('a');
  backLink.classList.add('mobileMenu__backLink');
  backLink.innerText = backText;
  li.appendChild(backLink);

  backLink.addEventListener('click', function () {
    const openItem = backLink.closest('.hasChildren.is-open');
    if (!openItem) return;
    const childUl = openItem.querySelector('ul');
    openItem.classList.remove('is-open');
    if (childUl) {
      childUl.scrollTop = 0;
      childUl.style.overflow = '';
    }
  });

  wrapper.prepend(li);
}

function buildChildrenHeader(wrapper, parentLink) {
  const li = document.createElement('li');
  const header = document.createElement('a');
  header.classList.add('mobileMenu__subHeader');
  header.innerText = parentLink.innerText;
  if (parentLink.tagName === 'A') {
    header.href = parentLink.href;
  }
  li.appendChild(header);
  wrapper.prepend(li);
}

// Verkabelt einen einzelnen <li>-Knoten: Hat er ein direktes Kind-<ul>,
// wird sein direkter Link/Span (a oder span) zum Aufklapp-Trigger.
function initNavItem(li, mobileMenuBody) {
  let parentLink = null;
  let childUl = null;

  for (const child of li.children) {
    if (child.tagName === 'UL') childUl = child;
    if (child.tagName === 'A' || child.tagName === 'SPAN') {
      if (!parentLink) parentLink = child;
    }
  }

  if (!childUl || !parentLink) return;

  li.classList.add('hasChildren');

  parentLink.addEventListener('click', function (e) {
    const closestUl = parentLink.closest('ul');
    if (closestUl) closestUl.scrollTop = 0;

    if (li.classList.contains('is-open')) {
      li.classList.remove('is-open');
      parentLink.classList.remove('is-active');
      if (closestUl) closestUl.style.overflow = '';
    } else {
      li.classList.add('is-open');
      parentLink.classList.add('is-active');
      if (closestUl) closestUl.style.overflow = 'hidden';
    }
    if (mobileMenuBody) mobileMenuBody.scrollTop = 0;
    e.preventDefault();
  });

  buildChildrenHeader(childUl, parentLink);
  buildChildrenBackLink(childUl);
}

function buildMobileMenu(menu) {
  const mobileMenuBody = menu.querySelector('.mobileMenu__body');

  for (const navigation of menu.querySelectorAll('.mobileMenu__navigation')) {
    for (const li of navigation.querySelectorAll('li')) {
      initNavItem(li, mobileMenuBody);
    }
    for (const active of navigation.querySelectorAll('.is-active, .is-active_tree')) {
      active.classList.add('is-open');
    }
  }
}

function showMobileMenu(menu, overlay, toggle) {
  fadeIn(overlay, FADE_DURATION, function () {
    menu.classList.add('is-open');
    toggle.classList.add('is-active');
    document.body.classList.add('is-mobilemenuopen');
  });
}

function hideMobileMenu(menu, overlay, toggle) {
  menu.classList.remove('is-open');
  toggle.classList.remove('is-active');
  document.body.classList.remove('is-mobilemenuopen');
  fadeOut(overlay, FADE_DURATION);
}

export function initMobileMenu() {
  const menu = document.querySelector('.mobileMenu');
  const toggle = document.getElementById('js-toggleNavigation');
  const overlay = document.getElementById('overlay');

  if (!menu || !toggle || !overlay) return;

  const close = menu.querySelector('.mobileMenu__close');

  buildMobileMenu(menu);

  toggle.addEventListener('click', () => showMobileMenu(menu, overlay, toggle));
  if (close) {
    close.addEventListener('click', () => hideMobileMenu(menu, overlay, toggle));
  }
  overlay.addEventListener('click', () => hideMobileMenu(menu, overlay, toggle));
}
